import { useCallback } from 'react';
import { Routes } from 'types';
import styled from '@emotion/styled';
import { setSessionStorage } from 'utils';
import { STATE_SESSION_STORAGE_KEY } from 'context/context';

export function DevTeleport({ setAllowNavigationToAllRoutes }: { setAllowNavigationToAllRoutes: () => void }) {
  const teleport = useCallback(async (path: string) => {
    setAllowNavigationToAllRoutes();
    setSessionStorage(STATE_SESSION_STORAGE_KEY, {});
    window.location.href = path;
  }, [setAllowNavigationToAllRoutes]);

  return (
    <Wrapper>
      {buttons.map(({ label, path }) => (
        <button key={label} onClick={() => teleport(path)}>{label}</button>
      ))}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid #d6ebff;

  button {
    padding: 0.5rem 1rem;
    background-color: #d6ebff;
    border: none;
    cursor: pointer;
    font-weight: 600;
  }
`;

const buttons = [
  {
    label: 'Outcome',
    path: Routes.outcome,
  },
  {
    label: 'SMP AU & show Bank Connect',
    path: '/main?source=smp-au&appNum=1234567890123&assessmentId=mockAssessmentId',
  },
  {
    label: 'SMP AU & hide Bank Connect',
    path: '/main?source=smp-au&appNum=1234567890123',
  },
  {
    label: 'SMP NZ & show Bank Connect',
    path: '/main?source=smp-nz&appNum=1234567890123&assessmentId=mockAssessmentId',
  },
  {
    label: 'SMP NZ & hide Bank Connect',
    path: '/main?source=smp-nz&appNum=1234567890123',
  },
  {
    label: 'CLI AU & show Bank Connect',
    path: '/main?source=cli-au&appNum=1234567890123&assessmentId=mockAssessmentId',
  },
  {
    label: 'CLI AU & hide Bank Connect',
    path: '/main?source=cli-au&appNum=1234567890123',
  },
  {
    label: 'Apply NZ & show Bank Connect & in-store channel',
    path: '/main?source=apply-nz&appNum=1234567890123&channel=instore&assessmentId=mockAssessmentId',
  },
  {
    label: 'Apply NZ & hide Bank Connect & default channel',
    path: '/main?source=apply-nz&appNum=1234567890123',
  },
  {
    label: 'Website AU',
    path: '/main?source=website-au',
  },
  {
    label: 'Website NZ',
    path: '/main?source=website-nz',
  },
  {
    label: 'ACH IDV AU - Additional Card Holder Identity Verification AU',
    path: '/ach-consents?operation=ach-au&appNum=1234567890123&dev=true',
  },
  {
    label: 'ACH IDV NZ - Additional Card Holder Identity Verification NZ',
    path: '/ach-consents?operation=ach-nz&appNum=1234567890123&dev=true',
  },
  {
    label: "ACH POA NZ - Additional Card Holder Proof of Address NZ",
    path: '/ach-doc-upload?source=ach-nz&appNum=1234567890123',
  }
]
